import { LayoutGrid, Play, Workflow } from "lucide-react";
import type { ComponentType } from "react";
import { storyWorkspaceModesCopy as copy } from "./storyWorkspaceModes.copy";

/** The story workspace's modes. Not `StoryMode`, which is the output-tab union. */
export type StoryWorkspaceModeId = "build" | "present" | "explore";

export interface StoryWorkspaceModeDef {
  id: StoryWorkspaceModeId;
  label: string;
  icon: ComponentType<{ size?: number | string; "aria-hidden"?: boolean | "true" | "false" }>;
  /** Shown but not built yet: disabled with a Coming soon tag. */
  soon?: boolean;
}

export const STORY_WORKSPACE_MODES: readonly StoryWorkspaceModeDef[] = [
  { id: "build", label: copy.build, icon: LayoutGrid },
  { id: "present", label: copy.present, icon: Play },
  // PENDING: PENDING-EXPLORE (sample nodes where the story has no real data; marked in the page)
  { id: "explore", label: copy.explore, icon: Workflow },
];

/** Modes a user can switch to today. */
export const isStoryWorkspaceModeLive = (id: StoryWorkspaceModeId): boolean =>
  !STORY_WORKSPACE_MODES.find((mode) => mode.id === id)?.soon;
